/* eslint-disable camelcase */
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { SearchedEmployeType } from '../../features/coaching/revGen/type';
import ReadConversationModalBody from '../../components/readConversationModalBody/ReadConversationModalBody';
import { useGetDirectReporteesQuery } from '../../features/coaching/coachingHistoryGrid/coachingHistoryGridSlice';
import NewConversationLog from '../../features/coaching/conversationLogs/newConversationLog/NewConversationLog';
import ReadConversationLog from '../../features/coaching/conversationLogs/readConversationLog/ReadConversationLog';
import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    selectCurrentIsHC,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../pages/login/authSlice';
import { datetimeToDate } from '../../utils/dateFormat';
import { CoachingEntityTypes, CoachingTabs } from '../../utils/typeConstants';
import { DateTemplate } from '../dateTemplate/DateTemplate';
import { GetTeamOptions, exportConversationExcel, exportExcel, getRole } from './conversation-service';
import './conversation.scss';
import { useGetCoachingConversationViewQuery } from './conversationSlice';
import { EmployeeSearchPopUp } from '../../features/coaching/employeeSearchPopUp/EmployeeSearchPopUp';

interface ConversationProps {
    // inputMonth: number;
    // inputYear: number;
    date?: Date;
    setMonth?: (month: number) => void;
    setYear?: (year: number) => void;
    setDate?: (date: Date) => void;
    via?: string;
    entityId?: string;
    entityDate?: string;
    teamOptionId?: string;
}
// eslint-disable-next-line max-statements
const Conversation = (props: ConversationProps) => {
    const newDate = new Date(props.date || new Date());
    const firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    const lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
    const [conversationData, setConversationData] = useState([]);
    const [conversationRowData, setConversationRowData] = useState<any>({});
    const [teamOptions, setTeamOptions] = useState<any>([]);
    const [selectedFromDate, setSelectedFromDate] = useState<any>(firstDay);
    const [selectedToDate, setSelectedToDate] = useState<any>(lastDay);
    const [selectedTeamOption, setSelectedTeamOption] = useState<string>('');
    const [selectedRowItem, setSelectedRowItem] = useState<any>({});
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [empNo, setEmpNo] = useState<any>();
    const loggedUser = useSelector(selectCurrentEmpid);
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [categories, setCategories] = useState<any[]>();
    const [viewState, setViewState] = useState<string>('new');
    const [showNewConversationModal, setshowNewConversationModal] = useState(false);
    const [selectedEmpList, setSelectedEmpList] = useState<any>();
    const [selectedEmp, setSelectedEmp] = useState<string>('');
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor=useSelector(selectIsPseudoSupervisor);
    const [displayModal, setDisplayModal] = useState(false);
    const [commentView, setCommentView] = useState(false);
    const [isResponse, setIsResponse] = useState(false);
    const [filters, setFilters] = useState<any>();
    const [selectedMonth, setSelectedMonth] = useState<any>();
    const [selectedYear, setSelectedYear] = useState<any>();
    const [recieverId, setRecieverId] = useState<string>('');
    const [receiverName, setReceiverName] = useState<string>('');
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isHC = useSelector(selectCurrentIsHC);
    const [searchVisible, setSearchVisible] = useState<boolean>(false);
    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
        'employee_name': '',
        'employee_number': '',
        'location': '',
        'job_title': '',
    });
    // const [newConversationDetails, setNewConversationDetails] = useState(null);
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        // @ts-ignore
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            recipient: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            author: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            conversation_subject: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            category_name: { value: null, matchMode: FilterMatchMode.IN },
            conversation_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            conversation_description: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
        });
        setGlobalFilterValue('');
    };
    const clearFilter = () => {
        initFilters();
    };
    useEffect(() => {
        setSelectedTeamOption('myTeamActivity');
    }, [props.entityId]);
    useEffect(() => {
        const selecedTeam = localStorage.getItem('selectedTeam');
        if(props.entityId && props?.entityDate){
            const entityDate = new Date(props?.entityDate);
            const firstDay = new Date(entityDate.getFullYear(), entityDate.getMonth(), 1);
            const lastDay = new Date(entityDate.getFullYear(), entityDate.getMonth() + 1, 0);
            setSelectedFromDate(firstDay);
            setSelectedToDate(lastDay);
            const teamOption = props.teamOptionId === '1' ? 'myActivity' : 'myTeamActivity';
            setSelectedTeamOption(teamOption);
        }
        else if (selecedTeam && teamOptions.some((item: any) => item.code === selecedTeam)) {
            setSelectedTeamOption(selecedTeam);
        } else {
            setSelectedTeamOption('myActivity')
        }
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        
        if (selecedTeam === 'search') {
            if (searchedUserString) {
                const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                
                setTimeout(() => {
                    setSearchedEmployee(searchedUser);
                    setEmpNo(searchedUser.employee_number);
                }, 50);
               
            } else {
                 setSearchVisible(true);
            }
        }
        initFilters();
    }, [teamOptions, props.entityId]);

    const teamSelected = () => {
        if (selectedTeamOption === 'myActivity') return 'myconversations'
        if (selectedTeamOption === 'myTeamActivity') return 'myteam'
        if (selectedTeamOption === 'search') return selectedTeamOption
        return null
    }
    const { data: conversationViewData } = useGetCoachingConversationViewQuery(
        {
            employeeNumber: loggedUser,
            searchOracleId: empNo,
            teamType: teamSelected(),
            userRole: getRole(userMngrRole,isPseudoSupervisor),
            fromDate: datetimeToDate(selectedFromDate),
            toDate: datetimeToDate(selectedToDate),
            viewAllEmps: (isAdmin || isHC) ,
        },
        {
            skip:
                !selectedFromDate ||
                !selectedToDate ||
                !selectedTeamOption ||
                !loggedUser ||
                !empNo ||
                selectedFromDate > selectedToDate,
        }
    );
    const { data: directReportees } = useGetDirectReporteesQuery(
        {
            employeeNo: parseInt(loggedUser, 10),
        },
        {
            skip: !loggedUser,
        }
    );
    useEffect(() => {
        if (selectedTeamOption === 'myTeamActivity') {
            if (directReportees?.data?.length > 0) {
                const employeeNames = directReportees.data.map((employee: any) => ({
                    label: employee.employee_name,
                    value: employee.employee_number,
                }));
                employeeNames.unshift({ label: 'All', value: 'all' });
                setSelectedEmp('all');
                setSelectedEmpList(employeeNames);
            } else {
                setSelectedEmpList([]);
                toast.info('No Direct reportees found');
            }
        }
    }, [directReportees, selectedTeamOption]);
    useEffect(() => {
        if (selectedFromDate && selectedToDate && selectedFromDate > selectedToDate) {
            toast.warning('Fromdate should not be greater than Todate');
        }
    }, [selectedFromDate, selectedToDate]);
    useEffect(() => {
        const data: any = conversationViewData?.data.map((element: any) => {
            return {
                coaching_conversation_id: element.coaching_conversation_id,
                create_date: new Date(element.create_date),
                conversation_date: new Date(element.conversation_date),
                recipient: element.recipient,
                author: element.author,
                conversation_subject: element.conversation_subject,
                conversation_description: element.conversation_description,
                visible_to_recipient: element.visible_to_recipient,
                category_id: element.category_id,
                category_name: element.category_name,
                core_value_id: element.core_value_id,
                core_value_name: element.core_value_name,
                responder: element.responder,
                response_date: element.response_date,
                response_description: element.response_description,
                conversation_documents:element.conversation_documents,
                acknowledge_employee_number:element.acknowledge_employee_number,
                acknowledge_date:element.acknowledge_date,
                acknowledged:element.acknowledged,
                employee_number: element.employee_number,
                coaching_behavior_name: element.coaching_behavior_name,
                coaching_skill_name: element.coaching_skill_name
            };
        });
        setConversationData(data);
        const distCategories = Array.from(
            new Set(conversationViewData?.data.map((item: any) => item.category_name))
        );
        setCategories(distCategories);
    }, [conversationViewData]);
    useEffect(() => {
        if(props.entityId){
            if(conversationData.length>0){
                const filteredData = conversationData.filter((item: any) => item.coaching_conversation_id.toString() === props.entityId);
                if(filteredData.length>0){
                    const event = { field: 'conversation_subject', rowData: filteredData[0] };
                    onConversionClick(event);
                }
            }
        }
    },[conversationData,props.entityId])
    useEffect(() => {
        setTeamOptions(GetTeamOptions(userMngrRole,isPseudoSupervisor));       
    }, [loggedUser]);
    useEffect(() => {
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeamOption === 'search') {
            if(searchedUserString){
                //const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
            }
            else{
            setEmpNo('');
            setSearchVisible(true);
            }
        } 
        else if(selectedTeamOption === '')
            setConversationData([]);
        else
            setEmpNo(loggedUser);
    }, [selectedTeamOption]);
    const handleReset = () => {
        setSelectedTeamOption('');
        setSearchVisible(false);
        setEmpNo('');
        localStorage.setItem('selectedTeam', '');
    };
    useEffect(() => {
        if(searchedEmployee?.employee_number && selectedTeamOption === 'search') {
        setEmpNo(searchedEmployee?.employee_number);
        }
    }, [searchedEmployee])
    const modalHeader = () => {
        return (
            <h4 className="pe-3">
                <span style={{ fontWeight: 700 }} className="pt-2">
                    {'Discussion Log'}
                </span>
            </h4>
        );
    };
    const modalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <Button
                    className="btn-secondary mr-2 me-2"
                    onClick={() => {
                        setDisplayModal(false);
                        setCommentView(false);
                        setIsResponse(false);
                    }}
                >
                    Close
                </Button>
                <Button
                    type="button"
                    icon="pi pi-upload me-2"
                    className="btn-export mr-2 me-2 float-end"
                    style={{ backgroundColor: '#007bff', color: '#fff' }}
                    onClick={() => {
                        exportConversationExcel('conversationlog', conversationRowData);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export
                </Button>
            </React.Fragment>
        );
    };
    const onConversionClick = (event: any) => {
        if (event.field === 'conversation_subject') {
            setConversationRowData([event?.rowData]);
            setDisplayModal(true);
            console.log(event?.rowData);
            const rowDetails = {
                coaching_conversation_id: event?.rowData?.coaching_conversation_id,
                conversation_subject: event?.rowData?.conversation_subject,
                conversation_date: event?.rowData?.conversation_date,
                core_value_name: event?.rowData?.core_value_name,
                coaching_conversation_category_name: event?.rowData?.category_name,
                conversation_description: event?.rowData?.conversation_description,
                visible_to_recipient: event?.rowData?.visible_to_recipient,
                author_name: event?.rowData?.author,
                author_employee_number: event?.rowData?.author.split('(')[1]?.slice(0, 7),
                response_date: event?.rowData?.response_date,
                response_description: event?.rowData?.response_description,
                response_by_name: event?.rowData?.responder,
                response_employee_number: event?.rowData?.responder?.split('(')[1]?.slice(0, 7),
                recipient: event?.rowData?.recipient,
                core_value_id: event?.rowData?.core_value_id,
                conversation_documents:event?.rowData?.conversation_documents,
                acknowledge_employee_number:event?.rowData?.acknowledge_employee_number,
                acknowledge_date:event?.rowData?.acknowledge_date,
                acknowledged:event?.rowData?.acknowledged,
                employee_number: event?.rowData?.employee_number,
                coaching_behavior_name: event?.rowData?.coaching_behavior_name,
                coaching_skill_name: event?.rowData?.coaching_skill_name,
            };
            setSelectedRowItem(rowDetails);
            if (rowDetails?.response_description !== null) {
                setIsResponse(true);
            } else {
                setIsResponse(false);
            }
        }
    };
    const renderHeader = () => {
        return (
            <div className="exportexcel">
                <Divider />
                <Button type="button" icon="pi pi-filter-slash" className='btn-primary' label="Clear" onClick={clearFilter} />
                <span className="p-input-icon-left ms-3">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-upload me-2"
                    className="btn-export mr-2 me-2 float-end"
                    style={{ backgroundColor: '#007bff', color: '#fff' }}
                    onClick={() => {
                        exportExcel(conversationData);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export All
                </Button>
            </div>
        );
    };
    const dateOnchanges = (e: any, options: any) => {
        options.filterCallback(e.value, options.index);
    };
    const dateBodyTemplate = (rowData: any) => {
        return DateTemplate(rowData.conversation_date);
    };
    const dateFilterTemplate = (options: any) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e: any) => dateOnchanges(e, options)}
                dateFormat="mm/dd/yy"
                placeholder="dd/mm/yy"
                mask="99/99/9999"
                showIcon
                className="custom-calendar"
            />
        );
    };
    const CategoryfilterOnChange = (options: any, e: any) => {
        options.filterCallback(e.value);
    };

    const handleGetData = (data: any) => {
        setReceiverName(data.empNo.employeeName)
        setSelectedMonth(data.selectedMonth)
        setSelectedYear(data.selectedYear)
        setRecieverId(data.empNo.employeeNumber)
    }
    const categoryFilterTemplate = (options: any) => {
        return (
            <MultiSelect
                value={options.value}
                options={categories}
                onChange={(e: any) => {
                    CategoryfilterOnChange(options, e);
                }}
                placeholder="Any"
                className="p-column-filter"
            />
        );
    };
    const header = renderHeader();

    const handleNewClick = () => {
        setViewState('new');
        setshowNewConversationModal(true);
    };

    const renderConversationLog = () => {
        if (viewState === 'read') {
            return (
                <ReadConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedUser}
                    authorName={loggedEmpUserName}
                    inputYear={selectedYear}
                    inputMonth={selectedMonth}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    via={CoachingTabs.Conversation}

                />
            );
        } else if (viewState === 'new') {
            return (
                <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedUser}
                    authorName={loggedEmpUserName}
                    recieverId={''}
                    receiverName={''}
                    via={CoachingTabs.Conversation}
                    date={props.date}
                    getData={(data: any) => { handleGetData(data) }}
                    coachingEntityId={0}
                    coachingEntityTypeId={props?.via === 'correctiveactions' ? CoachingEntityTypes.CorrectiveActions : CoachingEntityTypes.General}
                />
            );
        }
        return '';
    };
    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className="row mt-4 ms-2">
                <div className="col-md-2">
                    <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Filter Start Date From</h6>
                    <Calendar
                        id="fromDate"
                        value={selectedFromDate}

                        onChange={(e: any) => {
                            if(props.setDate !== undefined){props.setDate(e.value); }
                            if(props.setMonth !== undefined){props.setMonth(e.value.getMonth() + 1); }
                            if(props.setYear !== undefined){props.setYear(e.value.getFullYear()); }
                            setSelectedFromDate(e.value)
                        }}
                        showIcon
                        dateFormat="dd-M-yy"
                        className="custom-calendar"
                    />
                </div>
                <div className="col-md-2">
                    <h6 style={{ fontWeight: '600', fontSize: '16px' }}>To</h6>
                    <Calendar
                        id="toDate"
                        value={selectedToDate}
                        onChange={(e: any) => setSelectedToDate(e.value)}
                        showIcon
                        dateFormat="dd-M-yy"
                        className="custom-calendar"
                    />
                </div>
                <div
                    className="col-md-7 mt-4 align-items-end"
                    style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '70px' }}
                >
                    <Button
                        type="button"
                        icon="pi pi-plus me-2"
                        className="btn-secondary mr-2 me-2"
                        style={{ borderColor: '#3299FF', color: '#3299FF' }}
                        onClick={handleNewClick}
                    >
                        New Discussion
                    </Button>
                </div>
            </div>
            <div className="row mt-4 ms-2">
                {getRole(userMngrRole,isPseudoSupervisor) !== 'associate' && (
                    <div className="col-md-3">
                        <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Select Team</h6>
                        <Dropdown
                            value={selectedTeamOption}
                            onChange={(event) => {
                                localStorage.removeItem('searchedUser');
                                localStorage.setItem('selectedTeam', event.target.value);
                                setSelectedTeamOption(event.target.value);
                            }}
                            options={teamOptions}
                            optionLabel={'name'}
                            optionValue={'code'}
                            placeholder="Select Team"
                            className="custom-dropdown"
                            disabled={getRole(userMngrRole,isPseudoSupervisor) === 'associate'}
                        />
                    </div>
                )}
                {getRole(userMngrRole,isPseudoSupervisor) !== 'associate' && selectedTeamOption === 'search' && (
                    <div className="col-md-3">
                    <Button
                        label="Reset"
                        style={{ fontWeight: 400, marginTop: '27px'}}
                        className="btn-secondary mb-2"
                        onClick={handleReset}
                    />
                </div>
                )}
                {selectedTeamOption === 'selectedTeamOption' && (
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="selectedEmp">Select Employee</label>
                            <Dropdown
                                id="selectedEmp"
                                name="Select Employee"
                                placeholder="Select Employee"
                                className="custom-dropdown"
                                options={selectedEmpList}
                                optionValue={'value'}
                                optionLabel={'label'}
                                value={selectedEmp}
                                onChange={(event) => {
                                    setSelectedEmp(event.target.value);
                                    if (event.target.value === 'all') setEmpNo(loggedUser);
                                    else setEmpNo(event.target.value);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className="card-body p-0 align-middle text-center table mt-2">
                <DataTable
                    value={conversationData}
                    header={header}
                    dataKey="dispute_id"
                    className="conversationTable"
                    scrollable
                    scrollHeight="600px"
                    globalFilterFields={[
                        'conversation_date',
                        'conversation_subject',
                        'recipient',
                        'author',
                        'category_name',
                        'conversation_description',
                    ]}
                    filters={filters}
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    paginator={conversationData?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    onCellClick={onConversionClick}
                    cellSelection
                    selectionMode="single"
                >
                    <Column
                        header="Date"
                        field="conversation_date"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="conversation_date"
                        body={dateBodyTemplate}
                        filterField="conversation_date"
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                    />
                    <Column
                        header="Discussion"
                        field="conversation_subject"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem', color: '#007bff', textDecoration: 'underline' }}
                        sortable
                        sortField="conversation_subject"
                        filter
                        filterPlaceholder="Search by Discussion"
                    />
                    <Column
                        header="Recipient"
                        field="recipient"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="recipient"
                        filter
                        filterPlaceholder="Search by Recipient"
                    />
                    <Column
                        header="Author"
                        field="author"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="author"
                        filter
                        filterPlaceholder="Search by Author"
                    />
                    <Column
                        header="Category"
                        field="category_name"
                        sortable
                        sortField="category_name"
                        style={{ minWidth: '13rem' }}
                        filterField="category_name"
                        showFilterMatchModes={false}
                        filter
                        filterElement={categoryFilterTemplate}
                    />
                </DataTable>
            </div>
            <Dialog
                header={modalHeader}
                footer={modalFooter}
                visible={displayModal}
                style={{ width: '60vw' }}
                onHide={() => {
                    setDisplayModal(false);
                    setCommentView(false);
                    setIsResponse(false);
                }}
            >
                <ReadConversationModalBody
                    listItem={selectedRowItem}
                    setSelectedRowItem={setSelectedRowItem}
                    setCommentView={setCommentView}
                    setIsResponse={setIsResponse}
                    commentView={commentView}
                    isResponse={isResponse}
                    receiverName={selectedRowItem?.recipient}
                    receiverId={selectedRowItem?.recipient?.split('(')[1]?.slice(0, 7)}
                    coreValueId={selectedRowItem?.core_value_id}
                    convId={selectedRowItem?.coaching_conversation_id}
                    setDisplayModal={setDisplayModal}
                    acknowledged={selectedRowItem?.acknowledged}
                />
            </Dialog>
            {renderConversationLog()}
            {searchVisible && (
                <EmployeeSearchPopUp
                    visible={searchVisible}
                    searchedEmployee={searchedEmployee}
                    setVisible={setSearchVisible}
                    setSelectedTeam={setSelectedTeamOption}
                    setSearchedEmployee={setSearchedEmployee}
                />
            )}
        </div>
    );
};

export default Conversation;
